import { ResponseDTO } from '@/types';
import { QuestionnaireInfo } from '@/types/questionnaire';
import request from '@/utils/request';

/**
 * 根据问卷编号获取问卷信息（包含 Schema、答案和只读状态）
 * @param questionnaireNumber 问卷编号
 * @returns 问卷信息（包含 Schema、答案和 readOnly 状态）
 */
export function getQuestionnaireInfo(questionnaireNumber: number): Promise<QuestionnaireInfo> {
  return request
    .get<QuestionnaireInfo, ResponseDTO<QuestionnaireInfo>, void>(
      `/questionnaires/${questionnaireNumber}/info`,
    )
    .then((res) => res.data);
}

/**
 * 提交问卷答案
 * @param questionnaireNumber 问卷编号
 * @param answers 答案数据
 * @returns 提交结果
 */
export function submitQuestionnaire(
  questionnaireNumber: number,
  answers: Record<string, unknown>,
): Promise<{ success: boolean; message?: string }> {
  return request
    .post<
      { success: boolean; message?: string },
      ResponseDTO<{ success: boolean; message?: string }>,
      Record<string, unknown>
    >(`/questionnaires/${questionnaireNumber}/submit`, answers)
    .then((res) => res.data);
}

// POST /questionnaires/receipt { messageId: string }
export function sendQuestionnaireReceipt(
  messageId: string,
): Promise<{ success: boolean; message?: string }> {
  return request
    .post<{ success: boolean }, ResponseDTO<{ success: boolean }>, { messageId: string }>(
      `/questionnaires/receipt`,
      { messageId },
    )
    .then((res) => res.data);
}

// POST /questionnaires/feedback { messageId: string; action: 'later' | 'never' }
export function sendQuestionnaireFeedback(
  messageId: string,
  action: 'later' | 'never',
): Promise<{ success: boolean; message?: string }> {
  return request
    .post<
      { success: boolean; message?: string },
      ResponseDTO<{ success: boolean; message?: string }>,
      { messageId: string; action: 'later' | 'never' }
    >(`/questionnaires/feedback`, { messageId, action })
    .then((res) => res.data);
}
